import React from 'react';
import { Text } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';

const StyledPageStatus = styled.span<{ isHidden?: boolean }>`
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
`;

type Props = {
  isHidden?: boolean;
  children: string;
};

const PageStatus = ({ isHidden, children }: Props) => {
  return (
    <StyledPageStatus isHidden={isHidden} data-testid="page-status">
      <Text variant={'body-large'}>{children}</Text>
    </StyledPageStatus>
  );
};

export default PageStatus;
